import { CompaniesListResponse } from '@/api/company'
import { Filters, getDocuments, Location } from '@/api/documents'
import { useQueries } from 'react-query'

type DocumentsMap = Record<string, Location[]>

export const useCompaniesDocuments = (
  search: string,
  filters: Filters,
  companies: CompaniesListResponse,
) => {
  const companyList = companies || []

  const results = useQueries(
    companyList.map((company) => ({
      queryKey: ['documents', company.companyId, search, filters],
      queryFn: async () => {
        const response = await getDocuments(company.companyId, search, filters)
        return {
          companyId: company.companyId,
          companyName: company.name,
          files: response.data,
        }
      },
      enabled: !!company.companyId,
    })),
  )

  const documentsMap: DocumentsMap = {}

  results.forEach((result) => {
    if (result.data) {
      documentsMap[`${result.data.companyId}/${result.data.companyName}`] =
        result.data.files
    }
  })

  return {
    documentsMap,
    isLoading: results.some((result) => result.isLoading),
    isFetching: results.some((result) => result.isFetching),
    isError: results.some((result) => result.isError),
  }
}
